// src/components/BackButton.js
import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
function BackButton() {
  const navigate = useNavigate();
  return (
    <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }} style={{ color: "white" }}>
      Back
    </Button>
  );
}
export default BackButton;